import { config } from "config";
import * as React from "react";

import { Info, OpenInNew } from "@livechat/design-system-icons";
import { Button, Icon } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import Text from "components/layout/Text";

const EmptyState: React.FC = () => (
  <Flex marginV="60px" column alignItems="center">
    <Icon source={Info} size="xxxlarge" />

    <Text marginTop="25px" fontSize="20px" fontWeight="600" lineHeight="28px" textAlign="center">
      No developed apps yet
    </Text>

    <Text marginV="16px" fontSize="15px" lineHeight="22px" textAlign="center" maxWidth="540px">
      Bring your ideas to life and create your first app using the handy Building Blocks in the Developer Console.
    </Text>

    <Button
      kind="secondary"
      href={config.devConsoleCreateAppUrl}
      target="_blank"
      iconPosition="right"
      icon={<Icon source={OpenInNew} />}
    >
      Create first app
    </Button>
  </Flex>
);

export default EmptyState;
